import React, {} from "react";

 
function UnAuthorized() {
  return (
    <div className=" flex items-center justify-center h-screen">
      <div className="px-40 py-20 bg-white rounded-md shadow-xl">
        <div className="flex flex-col items-center">
          <h1 className="font-bold text-gray-800 text-9xl">401</h1>

          <h6 className="mb-2 text-2xl font-bold text-center text-gray-800 md:text-3xl">
            <span className="text-red-500">Oops!</span> User is not Autorized...
          </h6>

          {/* <p className="mb-8 text-center text-gray-500 md:text-lg">
            Please login from Shopify on KickStart QBO Connector app click.
          </p> */}
        </div>
      </div>
    </div>
  );
}

export default UnAuthorized;
